import { observer } from 'mobx-react-lite'
import type { LegendEditorViewModel } from '@/features/legends/LegendEditor/LegendEditorViewModel'
import { EditorPage } from '@/features/legends/components/EditorPage'
import { PageIntro } from '@/features/legends/components/PageIntro'
import { RoutingInspectorContainer } from '@/features/legends/routing/components/RoutingInspectorContainer'
import { RoutingPlansContainer } from '@/features/legends/routing/components/RoutingPlans/RoutingPlansContainer'
import { RoutingRequirementsContainer } from '@/features/legends/routing/components/RoutingRequirements/RoutingRequirementsContainer'

export interface RoutingTabContainerProps {
  vm: LegendEditorViewModel
}

const testId = 'legend-routing'

/**
 * The legend's qualifying requirements and routing plans, with an inspector
 * for the selected one.
 */
export const RoutingTabContainer = observer(function RoutingTabContainer({
  vm,
}: RoutingTabContainerProps) {
  return (
    <>
      <EditorPage testId={`${testId}-page`}>
        <PageIntro title="Routing">
          Decide which pros can see and pick up requests, and narrow the pool by
          preference for a while.
        </PageIntro>
        <RoutingRequirementsContainer
          vm={vm.routingVm}
          testId={`${testId}-requirements`}
        />
        <RoutingPlansContainer
          vm={vm.routingVm.plans}
          testId={`${testId}-plans`}
        />
      </EditorPage>
      <RoutingInspectorContainer
        vm={vm.routingVm}
        testId={`${testId}-inspector`}
      />
    </>
  )
})
